import api from "./axios";

class ServiceAdab {
  async generate(startDate, endDate, isExcel) {
    const { data } = await api.post(`/report-adab`, {
      startDate,
      endDate,
      isExcel,
    })

    return data
  }

  async generateByArt(startDate, endDate, artTrt, isExcel) {
    const { data } = await api.post(`/report-adab/art`, {
      startDate,
      endDate,
      artTrt,
      isExcel,
    })

    return data
  }

  async verify(isExcel) {
    const { data } = await api.get(`/report-adab/verify?isExcel=${isExcel}`)

    return data
  }
}

export default new ServiceAdab()
